<template>
  <div class="announcements" v-if="absentList.length > 0">
    <box :title="$t('announcements')">
      <div class="px-3 py-1">
        {{
          $t("announcements-info.absent", {
            consecutive: consecutive,
            alternating: alternating,
          })
        }}
        : <a @click="absentPerson">{{ absentList.length }} {{ $t("people") }}</a>
      </div>
    </box>
  </div>
</template>

<script>
import EosToastType from '../../model/EosToastType';
export default {
  mounted() {
    this.readwebkartsetting();
  },
  data() {
    return {
      consecutive: 0,
      alternating: 0,
      absentList: [],
    };
  },
  methods: {
    absentPerson(){
      this.$router.push({name:'absentPerson', params:{absentList:this.absentList}})
    },
    readwebkartsetting() {
      this.$store
        .dispatch("readwebkartsetting")
        .then((result) => {
          if (result.type === "success" && result.data) {
            this.consecutive = result.data.MotavaliDay;
            this.alternating = result.data.MotanavebDay;
            this.GetAbsentPersonelInCondition();
          } /*else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }*/
        })
        .catch(error => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
    },
    GetAbsentPersonelInCondition() {
      const params = new URLSearchParams();
      params.append("motavaliDay", this.consecutive);
      params.append("motanavebDay", this.alternating);

      this.$store
        .dispatch("GetAbsentPersonelInCondition", { params })
        .then((result) => {
          if (result.type === "success") {
            this.absentList = result.data;
          } /*else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }*/
        })
        .catch(error => {
          this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
        });
    },
  },
};
</script>

<style>
</style>